module.exports = __webpack_public_path__ + "static/media/90.ac5a14b0.jpg";